import React from 'react'

function EditCRN() {
  return (
    <div>EditCRN</div>
  )
}

export default EditCRN